export default __webpack_public_path__ + "static/media/smite.eb83b969.png";